import getTBWStore from "../../../stores/tbw-store";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import TBWPopUp from "./tbw-pop-up";

const CustomAlert = withLiteObserverAndTheme(() => {
  const type = getTBWStore().TBWPopUpType.get();

  switch (type) {
    case "ACTION_TBW":
      return <TBWPopUp />;
    default:
      return null;
  }
});

export default CustomAlert;
